import React from "react";
import { Center, Divider } from "@chakra-ui/react";

type CardDividerProps = {
  width?: number;
};

export function CardDivider({ width = 95 }: CardDividerProps) {
  if (width < 1 || width > 99)
    throw new Error("Divider width must between 0 and 100");
  return (
    <Center>
      <Divider w={`${width}%`} />
    </Center>
  );
}
